import { useEffect, useState } from "react";

// Countdown starts at 00:17:34 and restarts automatically when it reaches the end.
const CYCLE_SECONDS = 17 * 60 + 34;
const PAGE_START = Date.now();

const TOTAL_SPOTS = 100;
const START_SPOTS_LEFT = 9;
const MIN_SPOTS_LEFT = 3;
const SPOT_INTERVAL_SECONDS = 55;

function elapsedSeconds() {
  return Math.floor((Date.now() - PAGE_START) / 1000);
}

function getRemaining() {
  return CYCLE_SECONDS - (elapsedSeconds() % CYCLE_SECONDS);
}

function getSpotsLeft() {
  const used = Math.floor(elapsedSeconds() / SPOT_INTERVAL_SECONDS);
  return Math.max(MIN_SPOTS_LEFT, START_SPOTS_LEFT - used);
}

export function useCountdown() {
  const [remaining, setRemaining] = useState(getRemaining);

  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining()), 1000);
    return () => window.clearInterval(id);
  }, []);

  return {
    hours: Math.floor(remaining / 3600),
    minutes: Math.floor((remaining % 3600) / 60),
    seconds: remaining % 60,
  };
}

export function useSpotsLeft() {
  const [left, setLeft] = useState(getSpotsLeft);

  useEffect(() => {
    const id = window.setInterval(() => setLeft(getSpotsLeft()), 5000);
    return () => window.clearInterval(id);
  }, []);

  return {
    left,
    percent: Math.round(((TOTAL_SPOTS - left) / TOTAL_SPOTS) * 100),
  };
}
